module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-email",
    class: _vm.$style.root
  }, [_c('form', {
    staticClass: "col-lg-10 offset-lg-1 col-md-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tryLogin($event)
      }
    }
  }, [_c('form-input', {
    ref: "email",
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "placeholder": _vm.$t("pos.login.placeholder.email")
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "autocomplete": "current-password",
      "placeholder": _vm.$t("pos.login.placeholder.password")
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": !!_vm.loginError
    }
  }, [_vm._v(_vm._s(String(_vm.loginError)))]), _c('div', [_c('b-form-checkbox', {
    model: {
      value: (_vm.rememberMe),
      callback: function($$v) {
        _vm.rememberMe = $$v
      },
      expression: "rememberMe"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.remember-me')))])], 1), _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "className": "btn-login btn-success",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t('pos.login.login'))))])], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('router-link', {
    staticClass: "forgotpassword",
    attrs: {
      "to": "/could-not-sign-in",
      "target": "_BLANK",
      "data-test": "page-forgot-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.login.forgotpassword')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-602445fe"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/login/email/Email.vue
// module id = 2053
// module chunks = 1